module.exports = __webpack_public_path__ + "static/media/Logo_Small_Transparent.42378b6f.webp";